<template>
  <!-- Sending... -->
  <div class="flies-step sending-flies">
    <div class="d-flex align-items-center mb-2">
      <a
        href="javascript:void(0)"
        data-toggle="modal"
        class="d-inline-block mr-3"
        @click="cancelSend()"
      >
        <i class="icon-img icon-ms img-outline-close mt-1"></i>
      </a>
      <div>
        <h5 class="mb-1">Sending...</h5>
      </div>
    </div>
    <div class="sending-cont">
      <div class="text-center py-3">
        <div>
          <img src="images/transmore.png" alt="" width="80px" />
        </div>
        <h6 class="my-2">To {{ receiveClientName }}</h6>
      </div>
      <div class="py-2">
        <div class="progress mb-2">
          <div
            class="progress-bar"
            role="progressbar"
            :style="'width: ' + progress + '%;'"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <span>{{ progress }}%</span>
          </div>
        </div>
        <div class="d-flex justify-content-between small">
          <span>Total {{ filesInfo.total_num }} files</span>
          <span>
            <strong class="text-primary">
              {{ fileLengthFormat(uploadedSize + uploadingSize) }}
            </strong>
            / {{ fileLengthFormat(filesInfo.total_size) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileLengthFormat, stringToHex } from "../../../utils/Helpers";
import request from "../../../utils/Request";
import OSS from "ali-oss";
export default {
  name: "MySending",
  data() {
    return {
      uploadedSize: 0,
      uploadingSize: 0,
      oss: {
        region: "",
        accessKeyId: "",
        accessKeySecret: "",
        bucket: "",
        expire: ""
      },
      client: null,
      currentIndex: 0,
      isLoading: false,
      canReportProgress: true,
      transfer_ajax: null
    };
  },
  model: {
    prop: "transfer"
  },
  props: ["transfer"],
  computed: {
    filesInfo() {
      // 这里计算属性直接返回filesInfo，而不是filesInfo下的属性是因为total_size和total_num的改变无法触发更新事件
      return this.transfer.filesInfo;
    },
    receiveClientName() {
      return this.transfer.receive_client_name;
    },
    progress() {
      return parseInt(
        ((this.uploadedSize + this.uploadingSize) / this.filesInfo.total_size) *
          100
      );
    }
  },
  watch: {
    uploadingSize() {
      if (!this.canReportProgress) {
        return;
      }
      this.canReportProgress = false;
      request({
        baseURL: this.transfer.host_url,
        url: "update-status",
        method: "get",
        withCredentials: false,
        params: {
          keycode: this.transfer.transfer_key,
          progress: (
            (this.uploadedSize + this.uploadingSize) /
            this.filesInfo.total_size
          ).toFixed(2)
        }
      }).then(() => {
        let _self = this;
        setTimeout(function() {
          _self.canReportProgress = true;
        }, 1000);
      });
    }
  },
  created() {
    this.beginSend();
  },
  methods: {
    fileLengthFormat(size) {
      return fileLengthFormat(size);
    },
    beginSend() {
      request({
        url: "/v1/aliyun/sts"
      }).then(response => {
        if (response.StatusCode === 200) {
          this.oss.region = response.Endpoint;
          this.oss.accessKeyId = response.AccessKeyId;
          this.oss.accessKeySecret = response.AccessKeySecret;
          this.oss.bucket = response.Bucket;
          this.oss.expire = response.Expiration;
          this.oss.stsToken = response.SecurityToken;
          this.client = new OSS({
            endpoint: this.oss.region,
            accessKeyId: this.oss.accessKeyId,
            accessKeySecret: this.oss.accessKeySecret,
            stsToken: this.oss.stsToken,
            bucket: this.oss.bucket
          });
          this.uploadFile();
        }
      });
    },
    uploadFile() {
      // 判断oss sts过期时间
      if (
        new Date().getTime() >
        new Date(this.oss.expire).getTime() - 1000 * 30
      ) {
        this.beginSend();
        return;
      }
      try {
        let _self = this;
        let object_name =
          this.transfer.object_prefix +
          "/" +
          this.transfer.filesInfo.files[this.currentIndex].key;
        _self.client
          .multipartUpload(
            object_name,
            _self.transfer.files[this.currentIndex],
            {
              progress(percentage, cpt) {
                if (_self.transfer.step !== 4) {
                  _self.client.abortMultipartUpload(object_name, cpt.uploadId);
                  return;
                }
                _self.uploadingSize =
                  _self.transfer.filesInfo.files[_self.currentIndex].size *
                  percentage;
                request({
                  url: "/v1/transfer/set-status",
                  data: {
                    transfer_type: 1,
                    id: _self.transfer.id,
                    status: 2,
                    progress: _self.progress
                  }
                }).then(response => {
                  if (response.data.status > 3) {
                    _self.transfer.step = 6;
                    _self.transfer.status = response.data.status;
                  }
                });
              }
            }
          )
          .then(() => {
            _self.uploadedSize +=
              _self.transfer.filesInfo.files[_self.currentIndex].size;
            _self.uploadingSize = 0;

            request({
              url: "/v1/transfer/set-status",
              data: {
                transfer_type: 1,
                id: _self.transfer.id,
                status: 2,
                files_status: stringToHex(
                  JSON.stringify([
                    {
                      key: this.transfer.filesInfo.files[this.currentIndex].key,
                      status: 1
                    }
                  ])
                )
              }
            });

            this.currentIndex++;
            if (this.currentIndex < this.transfer.filesInfo.total_num) {
              this.uploadFile();
            } else {
              request({
                url: "/v1/transfer/set-status",
                data: {
                  transfer_type: 1,
                  id: _self.transfer.id,
                  status: 3
                }
              }).then(() => {});
              this.transfer.step = 6;
              this.transfer.status = 3;
            }
          });
      } catch (e) {
        // 捕获超时异常
        if (e.code === "ConnectionTimeoutError") {
          console.log("Timeout");
        }
        console.log(e);
      }
    },
    cancelSend() {
      this.transfer.step = 6;
      this.transfer.status = 5;
    },
    uploadInLAN() {
      let _self = this;
      let url =
        this.transfer.host_url +
        "upload?keycode=" +
        _self.transfer.transfer_key +
        "&filekey=" +
        _self.transfer.filesInfo.files[_self.currentIndex].key +
        "&filepath=" +
        stringToHex(_self.transfer.filesInfo.files[_self.currentIndex].name) +
        "&filetype=" +
        _self.transfer.filesInfo.files[_self.currentIndex].type;
      let upload_file = new FormData();
      upload_file.append("files[]", _self.transfer.files[_self.currentIndex]);
      _self.transfer_ajax = $.ajax({
        url: url,
        method: "post",
        data: upload_file,
        processData: false,
        contentType: false,
        cache: false,
        dataType: "json",
        xhr: function() {
          //用以显示上传进度
          let xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener(
              "progress",
              function(e) {
                if (_self.transfer.step !== 4) {
                  _self.transfer_ajax.abort();
                }
                let loaded =
                  e.loaded > _self.transfer.files[_self.currentIndex]
                    ? _self.transfer.files[_self.currentIndex]
                    : e.loaded;
                _self.uploadingSize = loaded;
              },
              false
            );
          }
          return xhr;
        },
        success: function(response) {
          if (response.code != 200) {
            _self.transfer.step = 6;
            _self.transfer.status = 8;
          }
          // 局域网更新单个文件下载状态

          request({
            baseURL: _self.transfer.host_url,
            url: "update-status",
            method: "get",
            withCredentials: false,
            dataType: "json",
            params: {
              keycode: _self.transfer.transfer_key,
              status: 1,
              filekey: _self.transfer.filesInfo.files[_self.currentIndex].key,
              filepath: stringToHex(
                _self.transfer.filesInfo.files[_self.currentIndex].name
              )
            }
          });

          _self.uploadedSize += parseInt(
            _self.transfer.files[_self.currentIndex].size
          );
          _self.uploadingSize = 0;
          _self.currentIndex++;
          if (_self.currentIndex < _self.transfer.filesInfo.total_num) {
            _self.uploadInLAN();
          } else {
            // 局域网通知APP端下载完成
            request({
              baseURL: _self.transfer.host_url,
              url: "update-status",
              method: "get",
              withCredentials: false,
              params: {
                keycode: _self.transfer.transfer_key,
                status: 6
              }
            });
            // 向服务器更新这次传输任务的状态
            request({
              url: "/v1/transfer/set-status",
              data: {
                transfer_type: 1,
                id: _self.transfer.id,
                status: 6
              }
            });
            // 跳转至成功页面
            _self.transfer.step = 6;
            _self.transfer.status = 3;
          }
        },
        error: function() {
          // 传输失败
          _self.transfer.step = 6;
          if (_self.transfer.status < 4) {
            _self.transfer.status = 8;
          }
        }
      });
    }
  }
};
</script>
